// extracted by mini-css-extract-plugin
export default {"button":"ButtonBase_button__si0Z+"};